var exports = {
  "j": "CustomPropertySelectPanelButton__hDWyv7",
};

module.exports = exports;
